import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { selfScheduleQueryOptions } from "@/api/check-in/self-schedule/self-schedule-query";
import { useSelfScheduleStore } from "@/stores/self-schedule-store";

/**
 * Resolves the booking event a `?bookingEventId=` link put in the store.
 *
 * Everything it returns is presentation only — the window, services and
 * provider are re-checked on availability and again on booking, so a patient
 * editing the id out of the URL just lands back on normal booking.
 */
export const useBookingEvent = () => {
  const $ = _c(6);
  const bookingEventId = useSelfScheduleStore(_temp);
  const cancelEventId = useSelfScheduleStore(_temp2);
  let t0;
  if ($[0] !== bookingEventId || $[1] !== cancelEventId) {
    t0 = selfScheduleQueryOptions.bookingEvent(bookingEventId ?? "", cancelEventId);
    $[0] = bookingEventId;
    $[1] = cancelEventId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = Boolean(bookingEventId);
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      retry: false
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useQuery(t2);
};
function _temp(state) {
  return state.bookingEventId;
}
function _temp2(state_0) {
  return state_0.cancelEventId;
}